import React from 'react';

export const FaceScreamIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M11 29.2969V8H7.5C6.67157 8 6 8.67157 6 9.5L6 26.4093C7.33326 27.6904 8.99989 28.6835 11 29.2969Z"
        fill="#5092FF"
      />
      <path
        d="M26 26.4072C24.6669 27.6888 23.0002 28.6824 21 29.2962V8H24.5C25.3284 8 26 8.67157 26 9.5V26.4072Z"
        fill="#5092FF"
      />
      <path
        d="M6.94871 9.31623C6.99716 9.17087 7.38448 8.5 8.50003 8.5C9.61558 8.5 10.0029 9.17087 10.0513 9.31623C10.226 9.84017 10.7923 10.1233 11.3163 9.94868C11.8402 9.77404 12.1234 9.20772 11.9487 8.68377C11.6638 7.82913 10.5845 6.5 8.50003 6.5C6.41558 6.5 5.33623 7.82913 5.05134 8.68377C4.8767 9.20772 5.15986 9.77404 5.6838 9.94868C6.20774 10.1233 6.77406 9.84017 6.94871 9.31623Z"
        fill="#402A32"
      />
      <path
        d="M21.9487 9.31623C21.9972 9.17087 22.3845 8.5 23.5 8.5C24.6156 8.5 25.0029 9.17087 25.0513 9.31623C25.226 9.84017 25.7923 10.1233 26.3163 9.94868C26.8402 9.77404 27.1234 9.20772 26.9487 8.68377C26.6638 7.82913 25.5845 6.5 23.5 6.5C21.4156 6.5 20.3362 7.82913 20.0513 8.68377C19.8767 9.20772 20.1599 9.77404 20.6838 9.94868C21.2077 10.1233 21.7741 9.84017 21.9487 9.31623Z"
        fill="#402A32"
      />
      <path
        d="M12 15C12 12.7909 13.7909 11 16 11C18.2091 11 20 12.7909 20 15V17C20 19.2091 18.2091 21 16 21C13.7909 21 12 19.2091 12 17V15Z"
        fill="#BB1D80"
      />
    </svg>
  );
};
